module.exports = __webpack_public_path__ + "img/1610192384.e5f066dd.png";